import i18n from '@/locales/i18n'
import { ADMIN_TEMPLATES_ROUTES } from '@/router/routes'
import type { RouteType } from '@rfc/rfc-components-library/types'

export const ADMIN_TEMPLATES_LIST_ROUTE_NAME = 'adminTemplatesList'

const routes: RouteType[] = [
    {
        path: ADMIN_TEMPLATES_ROUTES.baseUrl,
        name: ADMIN_TEMPLATES_LIST_ROUTE_NAME,
        component: () => import('@/views/AdminView/AdminTemplatesView/AdminTemplatesView.vue'),
        meta: {
            title: i18n.global.t('menu.adminTemplates'),
            authRequired: true
        }
    }
]

export default routes
